import pluginRegistrationIcon from './plugin-registration/icon.svg';
import pluginRegistrationLogo from './plugin-registration/logo.svg';
import translationManagementIcon from './translation-management/icon.svg';
import translationManagementLogo from './translation-management/logo.svg';
import componentExporterIcon from './component-exporter/icon.svg';
import componentExporterLogo from './component-exporter/logo.svg';
import dataverseMetadataBrowserIcon from './dataverse-metadata-browser/icon.svg';
import dataverseMetadataBrowserLogo from './dataverse-metadata-browser/logo.svg';
import ribbonWorkbenchIcon from './ribbon-workbench/icon.svg';
import ribbonWorkbenchLogo from './ribbon-workbench/logo.svg';
import wordTemplatePowerBiIcon from './word-template-powerbi/icon.svg';
import wordTemplatePowerBiLogo from './word-template-powerbi/logo.svg';
import customAuditRestoreIcon from './custom-audit-restore/icon.svg';
import customAuditRestoreLogo from './custom-audit-restore/logo.svg';
import customCrmFieldsRemoverIcon from './custom-crm-fields-remover/icon.svg';
import customCrmFieldsRemoverLogo from './custom-crm-fields-remover/logo.svg';
import customSecurityRoleBulkUpdateIcon from './custom-security-role-bulk-update/icon.svg';
import customSecurityRoleBulkUpdateLogo from './custom-security-role-bulk-update/logo.svg';
import customUsersBuManagerIcon from './custom-users-bu-manager/icon.svg';
import customUsersBuManagerLogo from './custom-users-bu-manager/logo.svg';
import environmentDriftMonitorIcon from './environment-drift-monitor/icon.svg';
import environmentDriftMonitorLogo from './environment-drift-monitor/logo.svg';
import priceListManagerIcon from './price-list-manager/icon.svg';
import priceListManagerLogo from './price-list-manager/logo.svg';
import dataQualityAssistantIcon from './data-quality-assistant/icon.svg';
import dataQualityAssistantLogo from './data-quality-assistant/logo.svg';
import pcfBuilderIcon from './pcf-builder/icon.svg';
import pcfBuilderLogo from './pcf-builder/logo.svg';
import fetchXmlBuilderIcon from './fetchxml-builder/icon.svg';
import fetchXmlBuilderLogo from './fetchxml-builder/logo.svg';
import traceLogAnalyzerIcon from './trace-log-analyzer/icon.svg';
import traceLogAnalyzerLogo from './trace-log-analyzer/logo.svg';
import flowRunMonitorIcon from './flow-run-monitor/icon.svg';
import flowRunMonitorLogo from './flow-run-monitor/logo.svg';
import securityRoleManagerIcon from './security-role-manager/icon.svg';
import securityRoleManagerLogo from './security-role-manager/logo.svg';
import accessCheckerIcon from './access-checker/icon.svg';
import accessCheckerLogo from './access-checker/logo.svg';
import entraUserManagerIcon from './entra-user-manager/icon.svg';
import entraUserManagerLogo from './entra-user-manager/logo.svg';
import csvRecordImportIcon from './csv-record-import/icon.svg';
import csvRecordImportLogo from './csv-record-import/logo.svg';
import formDesignerIcon from './form-designer/icon.svg';
import formDesignerLogo from './form-designer/logo.svg';
import solutionDeploymentIcon from './solution-deployment/icon.svg';
import solutionDeploymentLogo from './solution-deployment/logo.svg';
import solutionBuilderIcon from './solution-builder/icon.svg';
import solutionBuilderLogo from './solution-builder/logo.svg';
import bulkDataOperationsIcon from './bulk-data-operations/icon.svg';
import bulkDataOperationsLogo from './bulk-data-operations/logo.svg';
import dataverseCodeGeneratorIcon from './dataverse-code-generator/icon.svg';
import dataverseCodeGeneratorLogo from './dataverse-code-generator/logo.svg';
import aiCrmAnalystIcon from './ai-crm-analyst/icon.svg';
import aiCrmAnalystLogo from './ai-crm-analyst/logo.svg';
import entraUserImportIcon from './entra-user-import/icon.svg';
import entraUserImportLogo from './entra-user-import/logo.svg';
import organizationSettingsIcon from './organization-settings/icon.svg';
import organizationSettingsLogo from './organization-settings/logo.svg';
import recordTransferIcon from './record-transfer/icon.svg';
import recordTransferLogo from './record-transfer/logo.svg';
import sql4cdsIcon from './sql4cds/icon.svg';
import sql4cdsLogo from './sql4cds/logo.svg';
import wordDocumentGeneratorIcon from './word-document-generator/icon.svg';
import wordDocumentGeneratorLogo from './word-document-generator/logo.svg';

export interface ToolBrandAsset {
  icon: string;
  logo: string;
}

export const TOOL_BRAND_ASSETS: Record<string, ToolBrandAsset> = {
  'plugin-registration': {
    icon: pluginRegistrationIcon,
    logo: pluginRegistrationLogo,
  },
  'translation-management': {
    icon: translationManagementIcon,
    logo: translationManagementLogo,
  },
  'component-exporter': {
    icon: componentExporterIcon,
    logo: componentExporterLogo,
  },
  'dataverse-metadata-browser': {
    icon: dataverseMetadataBrowserIcon,
    logo: dataverseMetadataBrowserLogo,
  },
  'ribbon-workbench': {
    icon: ribbonWorkbenchIcon,
    logo: ribbonWorkbenchLogo,
  },
  'word-template-powerbi': {
    icon: wordTemplatePowerBiIcon,
    logo: wordTemplatePowerBiLogo,
  },
  'custom-audit-restore': {
    icon: customAuditRestoreIcon,
    logo: customAuditRestoreLogo,
  },
  'custom-crm-fields-remover': {
    icon: customCrmFieldsRemoverIcon,
    logo: customCrmFieldsRemoverLogo,
  },
  'custom-security-role-bulk-update': {
    icon: customSecurityRoleBulkUpdateIcon,
    logo: customSecurityRoleBulkUpdateLogo,
  },
  'custom-users-bu-manager': {
    icon: customUsersBuManagerIcon,
    logo: customUsersBuManagerLogo,
  },
  'environment-drift-monitor': {
    icon: environmentDriftMonitorIcon,
    logo: environmentDriftMonitorLogo,
  },
  'price-list-manager': {
    icon: priceListManagerIcon,
    logo: priceListManagerLogo,
  },
  'data-quality-assistant': {
    icon: dataQualityAssistantIcon,
    logo: dataQualityAssistantLogo,
  },
  'pcf-builder': {
    icon: pcfBuilderIcon,
    logo: pcfBuilderLogo,
  },
  'fetchxml-builder': {
    icon: fetchXmlBuilderIcon,
    logo: fetchXmlBuilderLogo,
  },
  'trace-log-analyzer': {
    icon: traceLogAnalyzerIcon,
    logo: traceLogAnalyzerLogo,
  },
  'flow-run-monitor': {
    icon: flowRunMonitorIcon,
    logo: flowRunMonitorLogo,
  },
  'form-designer': {
    icon: formDesignerIcon,
    logo: formDesignerLogo,
  },
  'csv-record-import': {
    icon: csvRecordImportIcon,
    logo: csvRecordImportLogo,
  },
  'entra-user-manager': {
    icon: entraUserManagerIcon,
    logo: entraUserManagerLogo,
  },
  'access-checker': {
    icon: accessCheckerIcon,
    logo: accessCheckerLogo,
  },
  'security-role-manager': {
    icon: securityRoleManagerIcon,
    logo: securityRoleManagerLogo,
  },
  'solution-deployment': {
    icon: solutionDeploymentIcon,
    logo: solutionDeploymentLogo,
  },
  'solution-builder': {
    icon: solutionBuilderIcon,
    logo: solutionBuilderLogo,
  },
  'bulk-data-operations': {
    icon: bulkDataOperationsIcon,
    logo: bulkDataOperationsLogo,
  },
  'dataverse-code-generator': {
    icon: dataverseCodeGeneratorIcon,
    logo: dataverseCodeGeneratorLogo,
  },
  'ai-crm-analyst': {
    icon: aiCrmAnalystIcon,
    logo: aiCrmAnalystLogo,
  },
  'entra-user-import': {
    icon: entraUserImportIcon,
    logo: entraUserImportLogo,
  },
  'organization-settings': {
    icon: organizationSettingsIcon,
    logo: organizationSettingsLogo,
  },
  'record-transfer': {
    icon: recordTransferIcon,
    logo: recordTransferLogo,
  },
  'sql4cds': {
    icon: sql4cdsIcon,
    logo: sql4cdsLogo,
  },
  'word-document-generator': {
    icon: wordDocumentGeneratorIcon,
    logo: wordDocumentGeneratorLogo,
  },
};
